import { Grid, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { AmountBlob } from '../../../atoms';
import { UserDnaCategory } from '../../../types';

const PUBMED_BASE = 'https://pubmed.ncbi.nlm.nih.gov/';

export interface CategoryDetailsProps {
  category: UserDnaCategory;
}

export const DnaCategoryDetails = (
  props: CategoryDetailsProps
): JSX.Element => {
  const sectionHeading = {
    fontSize: 14,
    opacity: 0.5,
  };

  const sectionInfo = {
    fontSize: 16,
    fontWeight: 'normal',
  };

  return (
    <>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        spacing={2}
        rowSpacing={2}
        sx={{
          paddingLeft: { xs: '16px' },
          paddingRight: { xs: '16px' },
          paddingTop: { xs: '16px' },
          paddingBottom: { xs: '16px' },
          marginTop: { xs: '10', md: '10' },
        }}
      >
        <Grid item xs={12}>
          <Typography sx={sectionHeading}>{'HEALTH CATEGORY'}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Tooltip
            title={props.category.description}
            placement="top-start"
            arrow
          >
            <Typography sx={{ fontSize: { xs: 48, md: 60 } }}>
              {props?.category.name}
            </Typography>
          </Tooltip>
        </Grid>
        <Grid item xs={12}>
          <Typography sx={sectionHeading}>
            {'NUTRIENT RECOMMENDATIONS'}
          </Typography>
        </Grid>
        <Grid item container xs={12} sx={{ padding: '16px' }}>
          <Typography sx={sectionInfo}>
            {props?.category.related_nutrients.join(', ')}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography sx={sectionHeading}>
            {'HOW YOUR DNA IMPACTS THIS CATEGORY'}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <AmountBlob
            text={props.category.amount_recommended}
            bold={true}
            large={true}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography sx={sectionHeading}>{'INFLUENTIAL GENES'}</Typography>
        </Grid>
        <Grid item container xs={12} sx={{ padding: '16px' }}>
          <Typography sx={sectionInfo}>
            {props?.category.influential_genes.join(', ')}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography sx={sectionHeading}>
            {props?.category.result_text_header.toLocaleUpperCase()}
          </Typography>
        </Grid>
        <Grid item container xs={12} sx={{ padding: '16px' }}>
          <Typography sx={sectionInfo}>
            {props?.category.result_text}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography sx={sectionHeading}>{'SCIENTIFIC PAPERS'}</Typography>
        </Grid>
        <Grid container item xs={12} alignItems="left" rowSpacing={1}>
          {props.category.scientific_papers.map((paper: string, i: number) => (
            <Grid
              item
              xs={4}
              key={`${i}-` + paper}
              onClick={() =>
                window.open(PUBMED_BASE + paper.split(' ')[1], '_blank')
              }
              sx={{ cursor: 'pointer' }}
            >
              <Typography
                sx={{ ...sectionInfo, textDecoration: 'underline' }}
                display="inline"
              >
                {paper}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </>
  );
};
